module.exports = __webpack_public_path__ + "static/wand_of_wonder-38d2afc4111b2c2ca930c357d9d70a03.jpeg";